import { ISetupService } from './ISetupService';
import { of as observableOf, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpRequestService } from '../../http-request.service';
import { apiURLs, LocationType } from '../../../globalcontants';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocationEntity } from '../../../models/Location/LocationEntity';
import { CustomerEnt, CustomerEntity } from '../../../models/Customer/CustomerEntity';
import { DepartmentEntity } from '../../../models/Application/DepartmentEntity';
import { InventoryChartAccountEntity } from '../../../models/Inventory/InventoryChartAccountEntity';
import { DescriptorEntity } from '../../../models/Utilities/DescriptorEntity';
import { SupplierEntity } from '../../../models/Supplier/SupplierEntity';
import { EatecSettingsEntity } from '../../../models/Application/EatecSettingsEntity';
import { ApplicationUserEntity } from 'src/app/shared/models/Account/ApplicationUserEntity';
import * as appApiResources from '../../../globalcontants';

@Injectable({
  providedIn: 'root'
})
export class SetupService implements ISetupService {
  constructor(private httpService: HttpRequestService) { }

  GetLocations(locationType: LocationType, siteId: number = 0): Observable<LocationEntity[]> {
    const inputParams = new HttpParams().set('locationType', locationType.toString()).set('siteId', siteId.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.SetupAPI.GetLocations);
  }

  GetCustomer(transferOutLocationId: number): Observable<CustomerEntity[]> {
    const inputParams = new HttpParams().set('transferOutLocationId', transferOutLocationId.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.SetupAPI.GetCustomer);
  }

  IsApprovalRequired(transTypeId: number): Observable<number> {
    const inputParams = new HttpParams().set('transTypeId', transTypeId.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.SetupAPI.IsApprovalRequired);
  }
  GetAccountDetails(): Observable<InventoryChartAccountEntity[]> {
    return this.httpService.GetHttpRequest(apiURLs.SetupAPI.GetAccountDetails);
  }
  GetDepartmentDetails(): Observable<DepartmentEntity[]> {
    return this.httpService.GetHttpRequest(apiURLs.SetupAPI.GetDepartmentDetails);
  }

  GetReasons(): Observable<DescriptorEntity[]> {
    return this.httpService.GetHttpRequest(apiURLs.SetupAPI.GetReasons);
  }

  SearchSupplier(searchValue: string): Observable<SupplierEntity[]> {
    const inputParams = new HttpParams().set('searchValue', searchValue.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.SetupAPI.SearchSuppliers);
  }

  GetSystemPrefrence(): Observable<any> {
    return this.httpService.GetHttpRequest(apiURLs.SetupAPI.GetSystemPrefrence);
  }

  GetFinancialPeriodCloseDate(): Observable<Date> {
    return this.httpService.GetHttpRequest(apiURLs.SetupAPI.GetFinancialPeriodCloseDate);
  }

  GetEatecGlobalSettings(groupName: string = 'all', lookupVariable: string = 'NA'): Observable<EatecSettingsEntity> {
    if (!window.localStorage.getItem(appApiResources.LocalStorageGlobalSettings)) {
      localStorage.removeItem(appApiResources.LocalStorageGlobalSettings.toString());
    }
    const inputParams = new HttpParams().set('groupName', groupName.toString()).set('lookupVariable', lookupVariable.toString());
    const response = this.httpService.GetHttpRequestId(inputParams, appApiResources.apiURLs.SetupAPI.GetEatecGlobalSettings).pipe(
      map(x => {
        window.localStorage.setItem(appApiResources.LocalStorageGlobalSettings, JSON.stringify(x));
        return x;
      })
    );
    return response;
  }
  GetUserMenus(Menuobject: any): Observable<ApplicationUserEntity> {
    const params = new HttpParams().set('userId', Menuobject.userId);
    const BodyParams = Menuobject.menuNames;
    return this.httpService.postHttpRequestParam(apiURLs.SetupAPI.GetUserMenus, BodyParams, params);
  }
  GetReceivingSuplier(siteId: any): Observable<SupplierEntity[]> {
    const inputParams = new HttpParams()
      .set('searchValue', 'Receiving')
      .set('siteId', siteId.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.SetupAPI.SearchSuppliers);
  }

  /**
   * @version 13.2 
   * @GetLoggedInLocation
   */
  GetLoggedInLocation(LocationUrl: string): Observable<any> {
    return this.httpService.GetHttpRequest(LocationUrl);
  }
  /**
 * @version 13.2 UI Modification
 * @param LocationParams 
 * @returns 
 */
  GetInventoryLocations(LocationParams: any): Observable<any> {
    const locationRequestUrl = apiURLs.InvertoryManagement.GetInventoryLocation + LocationParams;
    return this.httpService.GetHttpRequest(locationRequestUrl);
  }

  /**
 * @version 25.2 UI Modification
 * @returns 
 */
  GetMasterData(EndPointUrl): Observable<any> {
    return this.httpService.GetHttpRequest(EndPointUrl);
  }

  GetIn_TransitMasterData(): Observable<any> {
    const locationRequestUrl = apiURLs.InvertoryManagement.GetTransferMasterData;
    return this.httpService.GetHttpRequest(locationRequestUrl);
  }

  GetInventoryStatusByLocation(InventoryId: Array<any>): Observable<any> {
    let InventoryIdArray = InventoryId;
    const isArray = (Array.isArray(InventoryId))
    if (!isArray) {
      InventoryIdArray = [InventoryId]
    }
    const locationRequestUrl = apiURLs.InvertoryManagement.GetInventoryStatusByLocation
    return this.httpService.postHttpRequest(locationRequestUrl, InventoryIdArray);
  }

  GetCustomers(): Observable<any> {
    const customerRequestUrl = apiURLs.InvertoryManagement.GetCustomer;
    return this.httpService.GetHttpRequest(customerRequestUrl);
  }


  //13.2.1 added this method, above method need to removed while cleaning up after QA
  GetOrderedCustomers(CustomerParams: any): Observable<any> {
    const customerRequestUrl = apiURLs.InvertoryManagement.GetCustomer+CustomerParams;
    return this.httpService.GetHttpRequest(customerRequestUrl);
  }

  GetDepartments(): Observable<any> {
    const departmentRequestUrl = apiURLs.InvertoryManagement.GetDepartment;
    return this.httpService.GetHttpRequest(departmentRequestUrl);
  }

  GetChartofAccounts(): Observable<any> {
    const chartofAccountRequestUrl = apiURLs.InvertoryManagement.GetChartofAccount;
    return this.httpService.GetHttpRequest(chartofAccountRequestUrl);
  }

  GetSystemPrefrences(id: any): Observable<any> {
    return this.httpService.GetHttpRequest(apiURLs.SetupAPI.GetSystemPrefrences + id);
  }

  GetFinancialPeriods(params: any): Observable<any> {
    return this.httpService.GetHttpRequest(apiURLs.SetupAPI.GetFinancialPeriods + params);
  }
  GetApprovalRequiredStatus(transTypeId: number): Observable<any> {
    const reqHeadUrl = `${apiURLs.TransactionManagement.ApprovalRequired}/` + `${transTypeId}`;
    return this.httpService.GetHttpRequest(reqHeadUrl);
  }

  GetAllApprovers(params: any): Observable<any> {
    const reqHeadUrl = apiURLs.TransactionManagement.GetAllApprovers;
    return this.httpService.postHttpRequest(reqHeadUrl, params);
  }
  GetSites(params: any): any {
    const reqHeadUrl = `${apiURLs.InventoryAPI.GetSites}` + params;
    return this.httpService.GetHttpRequest(reqHeadUrl);
  }

  Getcurrencies(): any {
    const reqHeadUrl = `${apiURLs.InventoryAPI.GetCurrencies}`;
    return this.httpService.GetHttpRequest(reqHeadUrl);
  }

  GetV2Customers(CustomerParams: CustomerEnt): Observable<any> {
    const customerRequestUrl = apiURLs.InvertoryManagement.GetV2Customer;
    return this.httpService.postHttpRequest(customerRequestUrl,CustomerParams);
  }

  FetchAllFaculties(FacultyParams: CustomerEnt): Observable<any> {
    const EndPointUrl = apiURLs.InvertoryManagement.FetchAllFaculties;
    return this.httpService.postHttpRequest(EndPointUrl,FacultyParams);
  }

  GetApproversForReturn(params: any): Observable<any> {
    const reqHeadUrl = apiURLs.TransactionManagement.GetApproversForReturn;
    return this.httpService.postHttpRequest(reqHeadUrl, params);
  }

}
